import { utils } from 'frontendcommon-3'
import { loadMicroManifest, loadMicroScript, loadMicroApp } from '@/utils/micros'
import { config } from '@/dashboards'
const { getAsyncDataOnce } = utils.requestUtils

function prepareMicros (micros) {
  const allMicros = micros.map((micro) => {
    const getManifest = getAsyncDataOnce(() => loadMicroManifest(micro.baseUrl))
    const getScript = getAsyncDataOnce((src) => loadMicroScript(src))
    return {
      ...micro,
      manifest: getManifest,
      load: getAsyncDataOnce(async () => {
        // Load manifest
        const manifest = await getManifest.call()
        // Load micro dependencies, if is needed
        if (manifest.microDependecies?.length) {
          for (const dep of manifest.microDependecies) {
            if (dep === micro.id) continue
            const dependency = allMicros.find((m) => m.id === dep)
            if (dependency) await dependency.load.call()
          }
        }
        // Load micro script
        await getScript.call(manifest[manifest.mainFile])
        // Get micro modules
        return loadMicroApp(manifest)
      })
    }
  })
  return allMicros
}

export default prepareMicros([
  {
    baseUrl: `${config.MICRO_FRONTENDS}/favstore/dist/`,
    id: 'favstore',
    token_type: 'farmapremium',
    active: true
  }
])
